import React, { FC, useState } from 'react';
import { Box, IconButton, Popover, PopoverContent, PopoverTrigger } from '@chakra-ui/react';

import { Txt } from '@app/components/common';

import { FrequencyVisitsView } from './frequency-visit-view';

interface DetailViewModalProps {
  value?: string;
}

const FrequencyVisitsModal: FC<DetailViewModalProps> = ({ value }) => {
  const [frequency, setFrequency] = useState<number>(1);

  if (!value) {return <Txt color='gray.500'>Не указано</Txt>;}

  return (
    <Popover
      placement='bottom'
      closeOnBlur={false}
      trigger='hover'
    >
      <PopoverTrigger>
        <IconButton aria-label='more' >
          <Txt>{frequency}</Txt>
        </IconButton>
      </PopoverTrigger>

      <PopoverContent padding={2} width='410px' > 
        <Txt>Дни посещения ТТ</Txt>
        <Box  >
          <FrequencyVisitsView value={value} setFrequency={setFrequency} />
        </Box>
      </PopoverContent>
    </Popover>
  );
};

export default FrequencyVisitsModal;
